import { Announcement } from "../../api-entities/Announcement";
import { PresetArea } from "../../api-entities/PresetArea";
import { User } from "../../api-entities/User";
import { config } from "../../config";
import { ReturningAsyncThunk } from "../actions/All";
import { get } from "./HttpActionCreators";

export const getUserDetails: ReturningAsyncThunk<User> = dispatch =>
	dispatch(get<User>(`${config.apiUrl}whoami/`));

export const fetchArea: ReturningAsyncThunk<PresetArea[]> = dispatch =>
	dispatch(get<PresetArea[]>(`${config.apiUrl}area/`));

export const fetchArchiveTerms: ReturningAsyncThunk<{ text: string }> = dispatch =>
	dispatch(get<{ text: string }>(`${config.apiUrl}terms/`));

export const fetchAnnouncements: ReturningAsyncThunk<Announcement[]> = dispatch =>
	dispatch(get<Announcement[]>(`${config.apiUrl}announcement/`));

export const fetchUserAreas: ReturningAsyncThunk<PresetArea[]> = dispatch =>
	dispatch(get<PresetArea[]>(`${config.apiUrl}user-area/`));
